import { createContext } from 'react';
export const ScrollContext = /*#__PURE__*/createContext({
  top: false,
  bottom: false
});
export const SizeContext = /*#__PURE__*/createContext('xs');